import { useMemo } from "react";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import BackToTop from "@/components/feature/BackToTop";
import { useSeo } from "@/hooks/useSeo";
import { faqs } from "@/mocks/faqs";
import { scoops } from "@/mocks/scoops";
import Hero from "./components/Hero";
import Ticker from "./components/Ticker";
import FeaturedScoop from "./components/FeaturedScoop";
import LatestScoops from "./components/LatestScoops";
import CategoryGrid from "./components/CategoryGrid";
import VerifyProcess from "./components/VerifyProcess";
import ComparePreview from "./components/ComparePreview";
import Testimonials from "./components/Testimonials";
import FaqSection from "./components/FaqSection";
import CtaBanner from "./components/CtaBanner";

export default function Home() {
  const jsonLd = useMemo(
    () => [
      {
        "@type": "WebPage",
        "@id": "https://hdlyjgs.cn/#webpage",
        url: "https://hdlyjgs.cn/",
        name: "拾真社｜独家爆料实锤证据与来源求证平台",
        description:
          "拾真社专注独家爆料求证，整理实锤证据与原始来源，提供可信度辨析与真假对照，帮你判断事件可信度。",
        inLanguage: "zh-CN",
      },
      {
        "@type": "FAQPage",
        mainEntity: faqs.map((item) => ({
          "@type": "Question",
          name: item.q,
          acceptedAnswer: { "@type": "Answer", text: item.a },
        })),
      },
      {
        "@type": "ItemList",
        name: "拾真社最新求证档案",
        itemListElement: scoops.map((scoop, index) => ({
          "@type": "ListItem",
          position: index + 1,
          url: `https://hdlyjgs.cn/scoop/${scoop.id}`,
          name: scoop.title,
        })),
      },
    ],
    [],
  );

  useSeo({
    title: "拾真社｜独家爆料实锤证据与来源求证平台",
    description:
      "拾真社专注独家爆料求证，逐条整理实锤证据与原始来源，对网传真假信息做可信度辨析与真假对照。只摆事实讲依据，帮你判断事件可信度。",
    keywords: "独家爆料,独家爆料实锤,独家爆料证据,独家爆料来源,独家爆料求证,独家爆料真假",
    path: "/",
    jsonLd,
  });

  return (
    <div className="min-h-screen bg-background-50">
      <SiteHeader activePath="/" />
      <main>
        <Hero />
        <Ticker />
        <FeaturedScoop />
        <LatestScoops />
        <CategoryGrid />
        <VerifyProcess />
        <ComparePreview />
        <Testimonials />
        <FaqSection />
        <CtaBanner />
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}